import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from './auth.service';
import {RoleService} from './role.service';

@Injectable({
  providedIn: 'root'
})
export class SuperUserGuardService implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private roleService: RoleService,
  ) {}

  canActivate(): boolean {
      if (!this.auth.isAuthenticated()) {
          void this.router.navigate(['/login']);
          return false;
      }

    const userInfo = this.auth.getCurrentUserInfo();
      if (this.auth.isSuperUser()) {
      return true;
    }

    this.router.navigate([this.roleService.getDefaultRoute(userInfo?.role)]);
    return false;
  }
}
